// PARALLAX
var initialPos = window.pageYOffset;
var ctr = -1;
var element = document.querySelectorAll('.js-parallax');

window.addEventListener('scroll', function(){

  element.forEach( item => {
    var _currentPos = window.pageYOffset;
    var percent = [ _currentPos / (document.body.scrollHeight - window.innerHeight) ] * 200;

      if( initialPos > _currentPos ){
        item.style.setProperty('background-position', `center ${ctr * percent}px`);
      } else {
        item.style.setProperty('background-position', `center ${ctr * percent}px`);
      }

    initialPos = _currentPos;

  });

});

jQuery(document).ready(function($){
	$('#your-shopping-cart .quantity').each(function(){
		$(this).on('change',function(){
			$('.cart--button-update').css({'background':'#8DC63D','opacity':'1'});
			console.log('SUCCESS');
		});
	});
	$('#your-shopping-cart .quantity-select').each(function(){
		$(this).click(function(){
			$('.cart--button-update').css({'background':'#8DC63D','opacity':'1'});
			console.log('SUCCESS');
		});
	});
});

document.querySelectorAll('.site-nav--inner .site-nav__link').forEach(e=> {
	e.addEventListener('click', function(evt) {

		document.querySelectorAll('.site-nav--inner .site-nav__link').forEach(i=> {
			i.classList.remove('active')
		})
		e.classList.add('active');

		activeCards(e);
	})

	e.addEventListener('mouseover', function(evt) {
		evt.preventDefault()

		document.querySelectorAll('.site-nav--inner .site-nav__link').forEach(i=> {
			i.classList.remove('active')
		})
		e.classList.add('active')

		activeCards(e)
	})
})

if (document.querySelectorAll('.site-nav--inner .site-nav__link').length > 0) {
	document.querySelectorAll('.site-nav--inner .site-nav__link.active').forEach(e=> {
		activeCards(e)
	})
}



function activeCards(e) {
	document.querySelectorAll('.block-header').forEach(block=> {
		if (e.dataset.title == block.dataset.name) {
			block.classList.add('is-active')
		} else {
			block.classList.remove('is-active')
		}
	})

	// Get the value of the 'data-title' attribute
	const title = e.dataset.title;

	// Select all elements with class 'block-header' and filter them based on the condition
	const filteredHeaders = Array.from(document.querySelectorAll('.block-header')).filter(headerElement => {
		return headerElement.dataset.name === title;
	});

	
	// Get the count of filtered headers
	const itemsCount = filteredHeaders.length;
	const rightPanel = document.querySelector('.right-panel');

	rightPanel.classList.forEach(className => {
		// Check if the class contains the string 'items-total-'
		if (className.includes('items-total-')) {
			// Remove the class from the element
			rightPanel.classList.remove(className);
		}
	});

	if (itemsCount > 4) {
		document.querySelector('.right-panel').classList.add('items-total-small');
	} else { 
		document.querySelector('.right-panel').classList.add('items-total-large');
	}
}

document.querySelectorAll('.cart-mobile').forEach(e=> {
	e.addEventListener('click', function(evt) {
		evt.preventDefault()
	})
})